import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import App from './App.tsx';
import SocialPage from './pages/Social';
import './i18n';
import './styles/index.css';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminLoginForm } from './components/admin/AdminLoginForm';
import { ProtectedRoute } from './components/admin/ProtectedRoute';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { initializeConsent } from './utils/consent';

initializeConsent();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AdminAuthProvider>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/social" element={<SocialPage />} />
          <Route path="/internal/regai-admin/login" element={<AdminLoginForm />} />
          <Route
            path="/internal/regai-admin"
            element={(
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            )}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AdminAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
